<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="text-center">
      <h1>User</h1>
    </div>
    <div class="d-flex justify-content-end mx-5">
      <button
        class="btn btn-outline-primary"
        style="margin-right: 5rem"
        @click="uploadFiles"
      >
        Import
      </button>
      <input
        id="uploadFileExcel"
        ref="uploadFileExcel"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        size="1048576"
        capture="camera"
        hidden
        contain
        @change="getFile"
      />
      <button
        @click="() => $router.push({ name: 'DetailUser', type: 'add' })"
        class="btn btn-outline-primary"
      >
        Create
      </button>
    </div>
    <div class="d-flex flex-row-reverse mt-3">
      <div style="padding-right: 5.5rem">
        <a href="#" target="_blank" @click.prevent="downloadSampleFile()"
          >Download Sample File</a
        >
      </div>
    </div>
    <v-alert
      v-if="importError.length > 0"
      prominent
      dense
      dismissible
      type="error"
    >
      <ul v-for="error in importError" :key="error.field_name">
        <li style="list-style: none">
          {{ error.field_name }} : {{ error.message }}
        </li>
      </ul>
    </v-alert>
    <div class="text-center px-3">
      <ListUser />
    </div>
  </div>
</template>

<script>
import UserService from "@/services/api/user.service";
import ListUser from "./ListUser.vue";
export default {
  components: {
    ListUser,
  },
  data() {
    return {
      file: [],
      isLoading: false,
      importError: [],
    };
  },
  methods: {
    uploadFiles() {
      document.getElementById("uploadFileExcel").click();
    },
    getFile(e) {
      const file = e.target.files[0];
      if (file.size <= 1048576) {
        this.uploadExcel(file, e);
      } else {
        alert("ไฟล์มีขนาดใหญ่เกินไป");
        e.target.value = null;
      }
    },
    async uploadExcel(file, e) {
      try {
        this.isLoading = true;
        const formData = new FormData();
        formData.append("file", file);
        await UserService.uploadExcel(formData)
          .then((res) => {
            if (res.data.status === "failure") {
              this.importError = res.data.errors;
              this.isLoading = false;
              return;
            }
            e.target.value = null;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
            alert("ข้อมูลของไฟล์ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
            e.target.value = null;
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("Error: ", error);
      }
    },
    downloadSampleFile() {
      try {
        window.open(
          process.env.VUE_APP_HOST_API + "static/sample/sampleUsers.xlsx"
        );
      } catch (error) {
        console.log("Error: ", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
